// extracted by mini-css-extract-plugin
module.exports = {"root":"MyShelves__root","header":"MyShelves__header","counter":"MyShelves__counter","scrollListWrapper":"MyShelves__scrollListWrapper","scrollList":"MyShelves__scrollList"};